import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import React from 'react';
import { SVGAsset } from 'res';
import BaseToggleView from '../..';
import "./styles.css";

/**
 * @function ControlToggleView
 * @param {STRING} mainText - This is the main text that shows the title.
 * @param {STRING} subText - This is the smaller text that shows under the title.
 * @param {STRING} className - Additional classes to add to the ControlToggleView.
 * @return {React.Component}
 * @exported true
 * @description This is the ToggleView used for only toggling on and off Controls.
 * @example
 * <ControlToggleView className={"added-class"} mainText={"Heading goes here"} subText={"Smaller sub-text goes here."} />
 */
export default function ControlToggleView(props) {
  const mainText = props.mainText ?? "[Main Text]";
  const subText = props.subText ?? "[subText]";
  const className = props.className ?? "";
  const icon = props.icon ?? <SVGAsset id="RightChevronIcon" className="chevron-icon clickable" />;
  const disabledArrow = props.disabledArrow ? <DisabledPrompt>{icon}</DisabledPrompt>:icon;
  return (
    <div className={className + " control-toggle-view"}>
      <BaseToggleView icon={disabledArrow} mainText={mainText} subText={subText} onChange={ props.onChange } checked={ props.checked } dataPoint={props.dataPoint}/>
    </div>
  );
}